export default __webpack_public_path__ + "static/media/stockholmchocolate@2x.abfef010.jpg";